export class OnlinePaper {
    days: string;
    minite: string;
    title: string;
    discription: string;
    canAccessPaper: boolean;
    currentTime: Date;
    timeInterval: any;
    blockAt: string;
    endAt: string;
    startAt: string;
    resultReleaseAt: string;
    leftSeconds: number;
    type: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/model/OnlinePaper.ts